/**
 * The channel the table's Edit action uses to reach the page it is drawn on.
 *
 * A row's action button is mounted imperatively by the model's column formatter
 * (`new ComponentClass({ propsData, vuetify, store, router }).$mount()`), so it
 * has no parent in the page's component tree and cannot `$emit` to it. It IS
 * handed the store, though — so the store is how it asks the page for a dialog.
 *
 * `hostCount` is what lets the same button keep routing on pages that have no
 * dialog to open (the legacy `dev-model` Tabulator pages): a host registers
 * while it is mounted, and the button only diverts when one is listening.
 *
 * Deliberately NOT in the vuex-persist module list in store/index.js — a
 * half-open dialog is not state worth restoring into the next session.
 */
export default {
  state: {
    data: {
      hostCount: 0,
      /** { serviceKey, modelKey, modelId } — consumed and cleared by the host. */
      request: null,
    },
  },
  getters: {
    //
  },
  actions: {
    registerModelEditDialogHost(context) {
      context.commit("registerModelEditDialogHost");
    },
    unregisterModelEditDialogHost(context) {
      context.commit("unregisterModelEditDialogHost");
    },
    requestModelEdit(context, data) {
      context.commit("requestModelEdit", data);
    },
    clearModelEditRequest(context) {
      context.commit("clearModelEditRequest");
    },
  },
  mutations: {
    registerModelEditDialogHost(state) {
      state.data.hostCount += 1;
    },
    unregisterModelEditDialogHost(state) {
      state.data.hostCount = Math.max(0, state.data.hostCount - 1);
    },
    requestModelEdit(state, data) {
      state.data.request = {
        serviceKey: data.serviceKey,
        modelKey: data.modelKey,
        modelId: data.modelId,
      };
    },
    clearModelEditRequest(state) {
      state.data.request = null;
    },
  },
};
